function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 16h12V6H8v10zm0 2c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 016 16V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 018 2h12c.55 0 1.02.196 1.413.587C21.803 2.98 22 3.45 22 4v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0120 18H8zm-4 4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 012 20V6h2v14h14v2H4z"
})));